import React from "react";
import {connect} from "react-redux";
import EditBookLMetaData from "./forms/EditBookLMetaData";
import {chBooklTitle, chBooklDescription, chCha, deleteBookl} from "../action/books";
import axios from "axios";

class EditMetaData extends React.Component{
    constructor(props) {
      super(props);
      this.state = {};
      axios.defaults.headers.common['bookId'] = props.match.params.bookId;
    }
    chBooklTitle=(data)=>{this.setState({loading: true});this.props.chBooklTitle(data).then(msg => {this.setState({loading: false});window.location.reload();})};
    chBooklDescription=(data)=>{this.setState({loading: true});this.props.chBooklDescription(data).then(msg => {this.setState({loading: false});window.location.reload();})};
    deleteBookL=(data)=>{this.setState({loading: true});this.props.deleteBookl(data).then(msg => {this.setState({loading: false});this.props.history.push("/main");
            window.location.reload();})};
    chCha=(data)=>{this.setState({loading: true});this.props.chCha(data).then(msg => this.setState({loading: false}))};
    render(){
        return(
            <div>
                <h1 className="content_title">Edit Booklist</h1>
                {this.state.loading && (
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    )}
                {this.props.booklists && this.props.booklists[this.props.match.params.bookId] ? (
                <EditBookLMetaData 
                    booklists={this.props.booklists[this.props.match.params.bookId]}
                    AllbookLists={this.props.bookLists}
                    chBookTitle={this.chBooklTitle}
                    bookId = {this.props.match.params.bookId}
                    chBookDescription={this.chBooklDescription}
                    deleteBookL = {this.deleteBookL}
                    chTotalChapters={this.chCha}
                />):<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>}
                {console.log(this.props.booklists)}
            </div>
        );
    };
};

function mapStateToProps (state) {
    return {booklists: state.AllBooklists.bookLists}
}

export default connect(mapStateToProps, {chBooklTitle, chBooklDescription, chCha, deleteBookl})(EditMetaData);